module.exports = __webpack_public_path__ + "img/university-of-calgary-press-logo.0ded709c.png";